import UserContext from './context/UserContext';
import Content from './components/Content/Content';
import StartChatComponent from './components/StartChatComponent/StartChatComponent';
import {useEffect, useContext, useState} from 'react'
import ChatStarted from './components/ChatStarted/ChatStarted';


function OneComponent()
{

const appContext = useContext(UserContext)

  return(<Content>
    {
        appContext.chatStarted == false ?

   
    <StartChatComponent></StartChatComponent>

    : <ChatStarted></ChatStarted> }

</Content>)
}




export default OneComponent;